//Importación de librerias
//---------------SIVAC---------------
//Catalogos
import C006TiposRubro from '../../../src/components/SIVAC/Catalogos/C006TiposRubro.vue';
import C008TiposEstatusFirma from '../../../src/components/SIVAC/Catalogos/C008TiposEstatusFirma.vue';
import C009TiposTemporalidad from '../../../src/components/SIVAC/Catalogos/C009TiposTemporalidad.vue';
import C010TiposFirmoEnTiempo from '../../../src/components/SIVAC/Catalogos/C010TiposFirmoEnTiempo.vue';
import C013TiposEstatusProcesado from '../../../src/components/SIVAC/Catalogos/C013TiposEstatusProcesado.vue';
import C016TiposMovimientos from '../../../src/components/SIVAC/Catalogos/C016TiposMovimientos.vue';
import C019TiposBanco from '../../../src/components/SIVAC/Catalogos/C019TiposBanco.vue';
import C020TiposEstatusDevolucion from '../../../src/components/SIVAC/Catalogos/C020TiposEstatusDevolucion.vue';
import C004TiposAreaDeposito from '../../../src/components/SIVAC/Catalogos/C004TiposAreaDeposito';

//Creamos y asignamos los datos necesarios de SIVAC
const sivac = [
    { Proviene: 'SIVAC', Nombre: 'C006TiposRubro', datos: C006TiposRubro },
    { Proviene: 'SIVAC', Nombre: 'C008TiposEstatusFirma', datos: C008TiposEstatusFirma },
    { Proviene: 'SIVAC', Nombre: 'C009TiposTemporalidad', datos: C009TiposTemporalidad },
    { Proviene: 'SIVAC', Nombre: 'C010TiposFirmoEnTiempo', datos: C010TiposFirmoEnTiempo },
    { Proviene: 'SIVAC', Nombre: 'C013TiposEstatusProcesado', datos: C013TiposEstatusProcesado },
    { Proviene: 'SIVAC', Nombre: 'C016TiposMovimientos', datos: C016TiposMovimientos },
    { Proviene: 'SIVAC', Nombre: 'C019TiposBanco', datos: C019TiposBanco },
    { Proviene: 'SIVAC', Nombre: 'C020TiposEstatusDevolucion', datos: C020TiposEstatusDevolucion },
    { Proviene: 'SIVAC', Nombre: 'C004TiposAreaDeposito', datos: C004TiposAreaDeposito }
]

export default sivac;


//////////////////
// WEBPACK FOOTER
// ./static/js/catalogos/sivac.js
// module id = null
// module chunks = 